export enum HistoryFields {
    customer = "Customer",
    description = "Demand description",
    role = "Role",
    seniority = "Seniority",
    pdTotalPlanned = "PD Total Planned",
    location = "Location",
    status = "Status",
    projectId = "Project Id",
    employeeId = "Resource",
    responsible = "Responsible"
}